import { useEffect, useState } from "react";
import { Checkbox, Divider, Typography } from "antd";

import SearchInput from "../Forms/SearchInput";
import PrimaryButton from "../Forms/PrimaryButton";
import { useGlobalModal } from "../../context/SuccessModalProvider";

const { Title } = Typography;

const Clientaccess = ({
  plainOptions,
  handleSubmit,
  handleSelect,
  salesPerson,
  assignedSalesPerson,
  title = "Re-assign Salesperson",
  loading,
}) => {
  const { showPopup } = useGlobalModal();
  const [tempOptions, setTempOptions] = useState(plainOptions);
  const [searchText, setSearchText] = useState("");
  const onSearch = (value) => {
    setSearchText(value);
    setTempOptions(
      plainOptions.filter((item) => item.full_name?.toLowerCase().includes(value.toLowerCase()))
    );
  };

  useEffect(() => {
    setSearchText("");
    setTempOptions(plainOptions);
  }, [assignedSalesPerson]);

  return (
    <>
      <Title className=" font-abhaya" level={2}>
        {title}
      </Title>
      <Title className="" level={5}>
        Assigned Salesperson - <strong>{assignedSalesPerson || "None"}</strong>
      </Title>

      <div className="flex items-center mt-4 gap-4 flex-wrap">
        <SearchInput
          value={searchText}
          onSearch={onSearch}
          placeholder="Search for a salesperson"
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div className="mt-6 space-y-3">
        <div className="w-full px-4 text-left flex">
          <span className="w-[25%] text-left font-medium text-gray-700">#</span>
          <span className="text-gray-900 text-left w-[75%]">Salesperson Name</span>
        </div>
        <Divider />
        {tempOptions.map((item, i) => {
          const isSelected = salesPerson === item.user_id;
          return (
            <div
              key={i}
              onClick={() => handleSelect(item.user_id)}
              className={`flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-[#FBEEEC] hover:font-semibold rounded-md ${
                isSelected ? "bg-[#FBEEEC]" : "bg-white"
              }`}
            >
              <div className="w-full text-left flex justify-between">
                <span className="font-medium text-gray-700">{i + 1}</span>
                <span className="text-gray-900 text-left w-1/2">{item.full_name}</span>
                <span></span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="w-full mt-4 flex justify-center">
        <PrimaryButton
          text={"Save and Proceed"}
          className="me-[30px]"
          onClick={() => {
            if (!salesPerson || (Array.isArray(salesPerson) && salesPerson.length === 0)) {
              return showPopup({
                title: null,
                content: <span className="custom-modal-title">Please select a salesperson.</span>,
                onOk: () => console.log("Confirmed!"),
                className: "custom-success-modal",
              });
            }
            handleSubmit();
          }}
          loading={loading}
        />
      </div>
    </>
  );
};

export default Clientaccess;
